export default {
  getAttachment: (state) => state.attachment,
};
